import Greenbay1 from '../../Media/Greenbay/Kamar 4.webp'
import Greenbay2 from '../../Media/Greenbay/Kamar 4.webp'





const Kamar4images =[
    Greenbay1,Greenbay2
]

export default Kamar4images;